import React from 'react';
import { IconButton } from '@material-ui/core';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const CarouselArrow = props => {
    const { onClick, type } = props;

    return (
        <IconButton size="small" onClick={onClick}>
            {type === 'next' ? <NavigateNextIcon /> : <NavigateBeforeIcon />}
        </IconButton>
    );
};

export default CarouselArrow;
